document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          // CS-84: open on beforeadditem, dispatched the moment the shopper clicks, so the
          // drawer answers instantly; the afteradditem swap fills it when /cart/add returns.
          // The afteradditem open stays: it is the path for adds that skip the early event.
          document.body.addEventListener(
            'cascade:modalcart:beforeadditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
          document.body.addEventListener(
            'cascade:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
          // A failed add closes the drawer so the shopper is back at the button, where the
          // error message renders.
          document.body.addEventListener(
            'cascade:modalcart:addfailed',
            () => {
              Alpine.store('modals').close('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
